// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__27kQ9","label":"LabeledBox_label__3M7nj"};